// src/theme.js
import { grey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const getTheme = (mode: "dark" | "light") =>
    createTheme({
        palette: {
            mode,
            ...(mode === "dark"
                ? {
                      // Custom palette settings for dark mode
                      primary: {
                          main: "#1bace2"
                      },
                      secondary: {
                          main: "#2196f3"
                      },
                      background: {
                          default: "#202836",
                          paper: "#202836"
                      },
                      //   disabled: { main: "#1bace2" },
                      text: {
                          primary: "#fff",
                          secondary: grey[200],
                          disabled: grey[400]
                      }
                  }
                : {
                      // Custom palette settings for light mode
                      primary: {
                          main: "#1bace2"
                      },
                      secondary: {
                          main: "#2196f3"
                      },
                      //   disabled: { main: "#1bace2" },
                      background: {
                          default: "#f4f4f4",
                          paper: "#fff"
                      },
                      text: {
                          primary: "#000",
                          secondary: grey[900],
                          disabled: grey[700]
                      }
                  })
        }
    });
